import { IDeviceSettingsCommand } from '@api/Devices.api';
import { IRawSettings } from '@core/interfaces/IRawSettings';
import { ISettings } from '@core/interfaces/ISettings';

const getTimestamp = (value: unknown): number | null => {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value !== 'string') return null;

    const timestamp = Date.parse(value);
    return Number.isNaN(timestamp) ? null : timestamp;
};

const getDisplayedDeviceSettings = (
    settings: IRawSettings | Partial<ISettings> | undefined,
    command?: IDeviceSettingsCommand | null,
): IRawSettings => {
    const actualSettings: IRawSettings = { ...settings };
    if (!command?.settings || command.status === 'FAILED') {
        return actualSettings;
    }

    const isInProgress =
        command.status === 'PENDING' || command.status === 'SENDING';
    const settingsTimestamp = getTimestamp(actualSettings.ts);
    const completedTimestamp = getTimestamp(command.completed_at);
    const isCompletedSnapshotPending =
        command.status === 'COMPLETED' &&
        completedTimestamp !== null &&
        (settingsTimestamp === null || settingsTimestamp < completedTimestamp);

    if (!isInProgress && !isCompletedSnapshotPending) return actualSettings;

    return {
        ...actualSettings,
        ...command.settings,
    };
};

export default getDisplayedDeviceSettings;
